import { environment } from '@env/environment';
export const APP_CONSTANTS = {
 general: {
  LOGO_IMAGE_PATH: `${environment.endpoints.serviceNow}/Governx_logo.png`,

  MAIN_CONFIG_ENDPOINT: '/api/proxy/GetMainConfig',

  USER_DETAILS_ENDPOINT: '/api/proxy/GetUser',

  PERSONAS_ENDPOINT: '/api/proxy/GetPersona/{sys_id}',
},
 session: {
  IDLE_TIMEOUT_MS: 30 * 60 * 1000,

  SESSION_PROPERTIES_ENDPOINT:
    '/api/proxy/GetSessionConfig',
},
 cockpit: {
 COCKPIT_SUMMARY_ENDPOINT:
  '/api/proxy/GetCockpitSummary',

COCKPIT_DRILLDOWN_ENDPOINT:
  '/api/proxy/GetCockpitDrilldown',

  COCKPIT_LIST_ENDPOINT:
  '/api/proxy/GetList/{table_name}/{start_date}/{end_date}/{email}',

  COCKPIT_LIST_EXPORT_ENDPOINT:
  '/api/proxy/GetlistExport',

  AI_RECORD_INSIGHT_ENDPOINT:
    '/api/proxy/CreateRecordInsight',
},
help: {
  HELP_OPTIONS: '/api/proxy/GetKnowledge',

  HELP_ARTICLE_IMAGE_PATH: `${environment.endpoints.serviceNow}`,
},
 actions: {
  ACTION_INSIGHTS_ENDPOINT:
    '/api/proxy/GetActionInsights/{email}',

  ACTION_INSIGHTS_HISTORY_ENDPOINT:
    '/api/proxy/GetHistorySummary/{email}',

  ACTION_INSIGHTS_HISTORY_RECORDS_ENDPOINT:
    '/api/proxy/GetHistoryRecords/{config_sys_id}/{email}',

  ACTION_INSIGHTS_RECORDS_ENDPOINT:
    '/api/proxy/GetTableRecord/{config_sys_id}/{email}',

  PAGE_EVENT_ENDPOINT:
    '/api/proxy/GetPageEvent/{config_sys_id}/{email}',

  PRIORITY_ACTIONS_ENDPOINT:
    '/api/proxy/GetPARecords/{email}',

  VIEW_CHILD_ENDPOINT:
    '/api/proxy/GetViewChild',

  SHOW_CLOSED_CLARIFY_ENDPOINT:
    '/api/proxy/GetShowCloseClarify',

  SHOW_CLOSED_EXPORT_ENDPOINT:
    '/api/proxy/GetShowCloseExport',

  MINI_FORM_ENDPOINT:
  '/api/proxy/GetMiniForm/{table_name}/{sys_id}/{config_sys_id}/{user_email}',

  MINI_FORM_EMAIL_ENDPOINT:
    '/api/proxy/GetMiniFormEmail/{email_sys_id}/{user_email}',

  // ServiceNow-configured dynamic action popup (fields, labels, attachments) for a record + ui action.
  GETPOPUP:
    '/api/proxy/GetPopup/{table_name}/{sys_id}/{ui_action_sys_id}/{config_sys_id}/{user_email}',

  // Dropdown options for user/reference popup fields, loaded once per field when the popup opens.
  GETPOPUP_LOOKUP: '/api/proxy/GetPopupLookup/{field_sys_id}/{sys_id}/{user_email}',

  CLARIFY_CREATE_ENDPOINT:
    '/api/proxy/GetCreate',

  CLARIFY_USERS_ENDPOINT:
    '/api/proxy/GetDropDownUsers',

  CONTRACT_EMAIL_ENDPOINT:
    '/api/proxy/GetContract',

  INVOICE_CALENDAR_ENDPOINT:
  '/api/proxy/GetShowInvoiceCalendar',
  INVOICE_CALENDAR_BY_SUPPLIER_CONTRACT_ENDPOINT:
    '/api/proxy/GetShowInvoiceCalendar/{supplier}/{contract}',

    PURCHASE_ORDER_BY_SUPPLIER_CONTRACT_DATES_ENDPOINT:
      '/api/proxy/{supplier}/{contract}/{start_date}/{end_date}',
    PARENT_AGREEMENTS_BY_CONTRACT_ENDPOINT: '/api/proxy/GetParentAgreements',
    ACTION_EXECUTION_ENDPOINT: '/api/proxy/PostAction',

    ACTION_REPLY_ENDPOINT: '/api/proxy/ActionReply',

    ACTION_MORE_CLARITY_ENDPOINT: '/api/proxy/ActionMoreClarity',

  NEW_CLARIFY_ENDPOINT:
    '/api/proxy/CreateClarify',

  ACTION_EXPORT_ENDPOINT:
    '/api/proxy/GetExport/{email}/{configSysId}',

  ACTION_DOWNLOAD_ZIP_ENDPOINT:
    '/api/proxy/GetDownloadZip',

  UPLOAD_FILE_ENDPOINT:
    '/api/servicenow/api/now/attachment/file',

  ACTION_DATA_DOWNLOAD_ENDPOINT:
    '/api/proxy/GetDownloadList/{table_name}/{condition}',

 SLA_DATA_DOWNLOAD_ENDPOINT:
  '/api/proxy/GetDownloadList/x_isgi_isg_governa_sla_sum/workflow_state=1^active=true^sp_ownersISNOTEMPTY',
  DATA_UPLOAD_ENDPOINT:
    '/api/proxy/UploadHandler',

  UPDATE_FILE_NAME_ENDPOINT:
    '/api/proxy/UpdateFileName',

  DELETE_ATTACHMENT_ENDPOINT:
    '/api/proxy/DeleteAttachment',

  ATTACHMENT_SINGLE_FILE_MIME_TYPE:
    'application/octet-stream',

  SERVICENOW_ATTACHMENT_API_PREFIX:
    '/api/servicenow/api/now/attachment',

  SERVICENOW_API_PREFIX:
    '/api/proxy',

  INVOICE_SUBMIT_DOWNLOAD_TABLE:
    'x_isgi_isg_governa_fm_bksum',

  SLA_SUBMIT_UPLOAD_TABLE:
    'x_isgi_isg_governa_sla_sum',

  CLARIFICATION_TABLE_NAME:
    'x_isgi_isg_governa_one_clarification',

  CLARIFICATION_CONFIG_SYS_ID:
    '1e3da9502b57cb10f63bf85f4e91bf2b',

  CREATE_RISK_ENDPOINT:
    '/api/proxy/CreateRisk',

  CREATE_INVOICE_ENDPOINT:
    '/api/proxy/CreateInvoice',

  CREATE_ACTION_ENDPOINT:
    '/api/proxy/CreateAction',

  CREATE_ISSUE_ENDPOINT:
    '/api/proxy/CreateIssue',

  CREATE_DECISION_ENDPOINT:
    '/api/proxy/CreateDecision',

  CREATE_CCR_ENDPOINT:
    '/api/proxy/CreateCCR',

  SAVE_PREFERENCES_ENDPOINT:
    '/api/proxy/UserPreferences',

  GET_PREFERENCES_ENDPOINT:
    '/api/proxy/GetPreference',

    SINGLE_ATTACHMENT_FILE_ENDPOINT: '/api/servicenow/api/now/attachment/{sys_id}/file',
    USER_DROPDOWN_ENDPOINT: '/api/proxy/GetUserDropdown'
  },
  delegation: {
    DELEGATES_LIST_ENDPOINT: '/api/proxy/GetDelgationUsers/',

  DELEGATE_ENDPOINT: '/api/proxy/CreateDelegate',

  SINGLE_DELEGATE_ENDPOINT: '/api/proxy/SingleDelegationCreate',

  SHOW_DELEGATED_LIST_ENDPOINT:
    '/api/proxy/GetDelgationUsers/{email}',

  // Record-level process ids are the ServiceNow table name without the scope prefix.
  PROCESS_TABLE_PREFIX: 'x_isgi_isg_governa_',

  DEFAULT_RECORD_PROCESS: 'do_recurring',
},
} as const;
